import { useEffect, useRef, useState } from 'react';
import WebProductPriceEdit from './WebProductPriceEdit';
import WebProductPriceFileEdit from './WebProductPriceFileEdit';
import { Button, Popconfirm, Switch, Tooltip, Image, Space } from 'antd';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import AntDraggableModal from '../../../utilsTsx/universal/AntDraggableModal';

//组件 WebProductPrice
const WebProductPrice = (props: any) => {
    const ref = useRef<any>(undefined);
    const { data, closeModal, defaultService } = props;
    const apiId = 'webProductPrice';
    const [webUniversalVisible, setWebUniversalVisible] = useState(true);

    useEffect(() => {
    }, []);

    //表头
    const columnsHead = [
        {
            title: '产品',
            dataIndex: 'product',
            render: (text: any) =>
                (typeof text !== "undefined" && text !== null) ?
                    <Tooltip placement="topLeft" title={text.productName}>
                        {(text.productName.length >= 8 ? text.productName.substring(0, 8) + '......' : text.productName)}
                    </Tooltip>
                    : ''
        },
        {
            title: '单位',
            dataIndex: 'productUnit',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.unitName :
                '')
        },
        {
            title: '规格',
            dataIndex: 'productPriceSpecs_Name',
            // render: (text: any) =>
            //     (typeof text !== "undefined" && text !== null) ?
            //         <Tooltip placement="topLeft" title={text}>
            //             {(text.length >= 8 ? text.substring(0, 8) + '......' : text)}
            //         </Tooltip>
            //         : ''
        },
        {
            title: '原价',
            dataIndex: 'originalPrice',
        },
        {
            title: '现价',
            dataIndex: 'price',
        },
        {
            title: '库存',
            dataIndex: 'inventory',
        },
        {
            title: '推广促销',
            dataIndex: 'isPromoteSales',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                // onChange={(e) =>
                //     typeof handleChangeOne !== "undefined" ?
                //         handleChangeOne(record.id, 'isUse', e, apiName) :
                //         undefined
                // }
                />
            )
        }
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    const handleOk = (e: any) => {
        closeModal(true);
        // ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        closeModal(false);
        // ref.current.handleCancel();
    };
    const handleCreatedProductPrice = async () => {
        setWebUniversalVisible(false);
        //send productId
        fetchApi.POST(defaultService,
            {
                body: {
                    apiId: 'webProductPrice',
                    /** apiVaiable 是产品productId */
                    apiVaiable: data.id,
                    apiExtend: 'createdProductPrice'
                }
            }).then(res => {
                console.log(res);
                setWebUniversalVisible(true);
            })
    }

    //表头
    const filesColumns = [
        // {
        //     title: '产品',
        //     dataIndex: 'product',
        //     render: (text: any) => (text.productName)
        // },
        {
            title: '图片',
            dataIndex: 'id',
            render: (text: any, record: any) => (
                < Image
                    src={`${record.serverUrl}/${record.fileDestination}`}
                    width={60}
                    alt="图片" />
            )
        }
    ];

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '产品价格',
        apiId: 'webProductPrice',
        columns,
        sendPageData: { productId: data.id },
        displayOptions: {
            showFiles: true
        },
        editOptions: {
            Editor: WebProductPriceEdit
        },
        filesOptions: {
            FilesEditComponent: WebProductPriceFileEdit,
            filesColumns,
            fileParentId: 'productPriceId',
            insertFile: async (payload) => {
                const { sendPageData, fileRows } = payload;
                for (const item of fileRows) {
                    const insertRes = await fetchApi.POST(ref.current?.defaultService,
                        {
                            body: {
                                apiId: `${apiId}File`,
                                apiData: {
                                    [`${apiId}Id`]: sendPageData.productPriceId,
                                    serverUrl: item.serverUrl,
                                    fileId: item.id,
                                    fileDestination: `${item.destination}/${item.fileName}`,
                                    fileType: item.fileType,
                                    fileSize: item.fileSize,
                                    imageWidth: item.imageWidth,
                                    imageHeight: item.imageHeight,
                                    isDefault: false,
                                    isUse: true
                                }
                            }
                        })
                }
                return { success: true };
            },
        }
    };

    return (
        <>
            <AntDraggableModal
                title={'产品价格'}
                open={true}
                okText='退出'
                cancelText='取消'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1080}>
                <Space>
                    <Popconfirm title="根据产品规格设置，更新价格表，不存在规格价格将会删除，是否执行?"
                        onConfirm={() => handleCreatedProductPrice()}>
                        <Button type='primary'>更新产品价格表</Button>
                    </Popconfirm>
                </Space>
                <> </>
                {webUniversalVisible ? <WebUniversal {...extendProps} ref={ref} ></WebUniversal> : ''}
            </AntDraggableModal>
        </>
    )
}

export default WebProductPrice;